/**
 * RegisterPage — Iter 219 (Early Access)
 *
 * Public self-serve signup is disabled during Early Access. Anyone
 * landing on /register is bounced to the Access Request lead-capture
 * form. Existing bookmarks / marketing links keep working — they just
 * land on the correct entry point now.
 */
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export default function RegisterPage() {
  useEffect(() => {
    // Nothing to do — <Navigate/> handles the redirect.
  }, []);
  return <Navigate to="/request-access" replace data-testid="register-redirect" />;
}
